<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.modify_real_name')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
			<template #right>
				<span class="nav-right" @click="save()">{{$t("setting.save")}}</span>
			</template>
		</van-nav-bar>
		<van-cell-group>
			<van-field v-model="name" :label="$t('setting.name')" :placeholder="$t('setting.name_place')" />
		</van-cell-group>
		<p>{{$t("setting.name_tip")}}</p>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				name: "",
			};
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			back() {
				return window.history.back();
			},
			save() {
				this.$http({
					method: 'post',
					data: {
						realname: this.name
					},
					url: 'profile'
				}).then(res => {
					if (res.code == 1) {
						this.getUserInfo();
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code == 1) {
						this.name = res.data.realname;
					} else {
						this.$toast(res.msg);
					}
				})
			}
		},

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.van-cell {
		font-size: 35px;
		line-height: 80px;
	}

	.container p {
		padding: 0 15px;
		margin-top: 15px;
		font-size: 30px;
		color: #dc2037;
	}
</style>